<template>
  <div>
    <template v-if="sections">
      <form-accordion :title="$t('regles_metier.sections.general')" v-if="!hideInfo">
        <!-- GENERAL INFORMATION -->
        <b-row align-v="stretch">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="reglesMetier.nom" isMandatory
              inputType="text"
              :inputLabel="$t('regles_metier.nom')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="reglesMetier.montant"
              inputType="number"
              :inputLabel="$t('regles_metier.montant')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>
      <form-accordion :title="$t('regles_metier.sections.constraints')">
        <!-- CONSTRAINTS -->
        <b-row align-v="stretch">
          <b-col cols="12" md="6">
            <p>{{ $t("regles_metier.nbecheances") }}</p>
            <b-row>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.nbEcheances.min" isMandatory
                  inputType="number"
                  :minValue="1"
                  :maxValue="limitInstallment"
                  :inputLabel="$t('regles_metier.min')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="6" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.nbEcheances.max" isMandatory
                  inputType="number"
                  :minValue="1"
                  :maxValue="limitInstallment"
                  :inputLabel="$t('regles_metier.max')">
                </form-write-group-label-input>
              </b-col>
            </b-row>
            <label style="color:red">{{ checkNbEcheances() }}</label>
          </b-col>
          <b-col cols="12" md="6">
            <p>
              {{ $t('regles_metier.montant_min') }}
              <span class="color-red ml-1">* </span>
            </p>
            <b-form-group>
              <b-row>
                <b-col>
                  <b-form-radio v-model="reglesMetier.montantMinEcheanceType" value="percent">
                    {{ $t("regles_metier.montant_percent") }}
                  </b-form-radio>
                </b-col>
                <b-col>
                  <b-form-radio v-model="reglesMetier.montantMinEcheanceType" value="devise">
                    {{ $t("regles_metier.montant_devise") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group v-if="reglesMetier.montantMinEcheanceType === 'percent'"
              :label="reglesMetier.montantMinEcheancePercent + '%'">
              <b-form-input v-model="reglesMetier.montantMinEcheancePercent"
                type="range" min="0" max="100">
              </b-form-input>
            </b-form-group>
            <b-row>
              <b-col class="form-group">
                <form-write-group-label-input v-model="reglesMetier.montantMinEcheanceDevise"
                  inputType="number"
                  inputLabel=""
                  v-if="reglesMetier.montantMinEcheanceType === 'devise'">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row align-v="stretch">
          <b-col cols="12" md="6">
            <p>{{ $t("regles_metier.intervalle") }}</p>
          </b-col>
          <b-col cols="12" md="6">
            <p>{{ $t("regles_metier.delaisTotal") }}</p>
          </b-col>
        </b-row>
        <b-row align-v="stretch">
          <b-col cols="12" md="6">
            <b-row>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.intervalle.jour"
                  inputType="number"
                  :inputLabel="$t('regles_metier.jour')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.intervalle.mois"
                  inputType="number"
                  :inputLabel="$t('regles_metier.mois')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.intervalle.annee"
                  inputType="number"
                  :inputLabel="$t('regles_metier.annee')">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <b-row>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.delaisTotal.jour"
                  inputType="number"
                  :inputLabel="$t('regles_metier.jour')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.delaisTotal.mois"
                  inputType="number"
                  :inputLabel="$t('regles_metier.mois')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group">
                <form-write-group-label-input v-model="reglesMetier.delaisTotal.annee"
                  inputType="number"
                  :inputLabel="$t('regles_metier.annee')">
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="!hideInterests"/>
      <form-accordion :title="$t('regles_metier.sections.interests')" v-if="!hideInterests">
        <!-- INTEREST RATES -->
        <b-row align-v="stretch">
          <b-col cols="12" md="6">
            <b-form-group>
              <label>
                {{ $t('regles_metier.taux_interet') }}
                <span class="color-red ml-1">* </span>
              </label>
              <b-input-group append="%">
                <b-form-input
                  v-model="reglesMetier.tauxInterets"
                  type="number"
                  required>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group>
              <label>
                {{ $t('regles_metier.formule') }}
                <span class="color-red ml-1">* </span>
              </label>
              <b-input-group :prepend="$t('regles_metier.interets')">
                <b-form-input
                  v-model="reglesMetier.formule"
                  type="text"
                  required>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </form-accordion>
    </template>

    <template v-else>
      <!-- GENERAL INFORMATION -->
      <b-row align-v="stretch" v-if="!hideInfo">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="reglesMetier.nom" isMandatory
            inputType="text"
            :inputLabel="$t('regles_metier.nom')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="reglesMetier.montant" isMandatory
            inputType="text"
            :inputLabel="$t('regles_metier.montant')">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <!-- CONSTRAINTS -->
      <b-row align-v="stretch">
        <b-col cols="12" md="6">
          <p>{{ $t("regles_metier.nbecheances") }}</p>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.nbEcheances.min" isMandatory
                inputType="number"
                :minValue="1"
                :maxValue="limitInstallment"
                :inputLabel="$t('regles_metier.min')"
                @input="$emit('echeance-changed', reglesMetier.nbEcheances)">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.nbEcheances.max" isMandatory
                inputType="number"
                :minValue="1"
                :maxValue="limitInstallment"
                :inputLabel="$t('regles_metier.max')"
                @input="$emit('echeance-changed', reglesMetier.nbEcheances)">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <label style="color:red">{{ checkNbEcheances() }}</label>
        </b-col>
        <b-col cols="12" md="6">
          <p>
            {{ $t('regles_metier.montant_min') }}
            <span class="color-red ml-1">* </span>
          </p>
          <b-form-group>
            <b-row>
              <b-col>
                <b-form-radio v-model="reglesMetier.montantMinEcheanceType" value="percent">
                  {{ $t("regles_metier.montant_percent") }}
                </b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="reglesMetier.montantMinEcheanceType" value="devise">
                  {{ $t("regles_metier.montant_devise") }}
                </b-form-radio>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group v-if="reglesMetier.montantMinEcheanceType === 'percent'"
            :label="reglesMetier.montantMinEcheancePercent + '%'">
            <b-form-input v-model="reglesMetier.montantMinEcheancePercent"
              type="range" min="0" max="100">
            </b-form-input>
          </b-form-group>
          <b-row>
            <b-col>
              <form-write-group-label-input v-model="reglesMetier.montantMinEcheanceDevise"
                inputType="number"
                v-if="reglesMetier.montantMinEcheanceType === 'devise'"
                inputLabel="">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row align-v="stretch">
        <b-col cols="12" md="6">
          <p>{{ $t("regles_metier.intervalle") }}</p>
        </b-col>
        <b-col cols="12" md="6">
          <p>{{ $t("regles_metier.delaisTotal") }}</p>
        </b-col>
      </b-row>
      <b-row align-v="stretch">
        <b-col cols="12" md="6">
          <b-row>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.intervalle.jour"
                inputType="number"
                :inputLabel="$t('regles_metier.jour')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.intervalle.mois"
                inputType="number"
                :inputLabel="$t('regles_metier.mois')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.intervalle.annee"
                inputType="number"
                :inputLabel="$t('regles_metier.annee')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <b-row>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.delaisTotal.jour"
                inputType="number"
                :inputLabel="$t('regles_metier.jour')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.delaisTotal.mois"
                inputType="number"
                :inputLabel="$t('regles_metier.mois')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
              <form-write-group-label-input v-model="reglesMetier.delaisTotal.annee"
                inputType="number"
                :inputLabel="$t('regles_metier.annee')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- INTEREST RATES -->
      <b-row align-v="stretch"  v-if="!hideInterests">
        <b-col cols="12" md="6">
          <b-form-group>
            <label>
              {{ $t('regles_metier.taux_interet') }}
              <span class="color-red ml-1">* </span>
            </label>
            <b-input-group append="%">
              <b-form-input
                v-model="reglesMetier.tauxInterets"
                type="number"
                required>
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group>
            <label>
              {{ $t('regles_metier.formule') }}
              <span class="color-red ml-1">* </span>
            </label>
            <b-input-group :prepend="$t('regles_metier.interets')">
              <b-form-input
                v-model="reglesMetier.formule"
                type="text"
                required>
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'EcheancierReglesForm',
  props: ['value', 'hideInfo', 'hideInterests', 'sections'],
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      limitInstallment: 24
    }
  },
  created () {
    this.setHiddenValues()
  },
  updated () {
    this.setHiddenValues()
  },
  computed: {
    reglesMetier: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    setHiddenValues () {
      let temp = this.$R.clone(this.reglesMetier)
      if (this.hideInfo && this.reglesMetier.nom === '') {
        temp.nom = 'NA'
        temp.montant = '0'
        this.reglesMetier = temp
      }
      if (this.hideInterests &&
        (this.reglesMetier.tauxInterets === '' ||
        this.reglesMetier.formule === '')
      ) {
        temp.tauxInterets = 0
        temp.formule = 'C * t * n'
        this.reglesMetier = temp
      }
    },
    checkNbEcheances () {
      if (this.reglesMetier.nbEcheances.min > this.reglesMetier.nbEcheances.max) {
        return this.$t('regles_metier.min_max')
      }
      if (this.reglesMetier.nbEcheances.min <= 0 ||
        this.reglesMetier.nbEcheances.max <= 0) {
        return this.$t('regles_metier.one_installment')
      }
      if (this.reglesMetier.nbEcheances.min > this.limitInstallment ||
        this.reglesMetier.nbEcheances.max > this.limitInstallment) {
        return this.$t('regles_metier.too_installment') + ' ' + this.limitInstallment
      }
    }
  }
}
</script>

<style lang="css" scoped>
.input-group-text {
  font-size: small;
}
</style>
